<template>
    <div>
        <div class="loading" v-if="isLoading">{{ t('loading') }}</div>
        <transition
            name="page"
            mode="out-in"
        >
            <router-view  v-if="!isLoading" />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

import {
    UITEXTS_FETCH_NS,
    AUTHENTICATION_LOGOUT_NS,
} from "@/store/actions.type";

export default {
    name: 'App',

    computed: {
        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't'
        }),

        ...mapGetters('page', {
            isLoadingPage: 'isLoading',
        }),

        ...mapGetters('me', {
            isLoadingMe: 'isLoading',
        }),

        ...mapGetters('generalEntry', {
            isLoadingGeneralEntry: 'isLoading',
        }),

        isLoading() {
            return this.isLoadingUiTexts && this.isLoadingPage && this.isLoadingMe && this.isLoadingGeneralEntry;
        },
    },

    async created() {

        this.$http.interceptors.response.use(undefined, (error) => {

            return new Promise(async (resolve, reject) => {
                store.dispatch(AUTHENTICATION_LOGOUT_NS);
                this.$router.push({ name: 'login' });

                reject(error.response);
            });
        });

        await store.dispatch(UITEXTS_FETCH_NS);
    },
}
</script>
